module.exports = __webpack_public_path__ + "img/aseymour.5c821dc6.png";